// extracted by mini-css-extract-plugin
module.exports = {"small":"_d81f42b6","large":"_905696e7"};